import * as service from './service'
export default {
  namespace: 'equipmentMallCheckAddress',
  state: {
    cityData: {}
  },
  effects: {
    * getCity ({ payload }, { call, put }) {
      const res = yield call(service.getCity, payload)
      yield put({
        type: 'save',
        payload: {
          cityData: res.data.data
        }
      })
      return res.data
    },
    * submitCity ({ payload }, { call, put }) {
      const res = yield call(service.submitCity, payload)
      yield put({
        type: 'save',
        payload: {

        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
